module.exports = __webpack_public_path__ + "971f71b8e26134e41d1313600527c09e.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/AE.svg
// module id = cOe1
// module chunks = 0